import React from 'react';
import {PropTypes} from 'prop-types';
import {NormalizeClassNameString, ToString} from '../shared/utils';
import './loadingindicator.scss';

export class LoadingIconComponent extends React.Component {
	render() {
		const self = this;

        const className = NormalizeClassNameString('loading-icon ' + ToString(self.props.className));

		return (
			<span className={className}>
				<span className="fa fa-sun-o fa-spin" />
				<span className="fa fa-sun-o fa-spin-ccw"/>
			</span>
		)
	}
}
LoadingIconComponent.propTypes = {
    className: PropTypes.string
}

export class LoadingIndicatorComponent extends React.Component {
	render() {
		const {message, visible} = this.props;
		
        if (!visible) {
            return null;
        }

		return (
			<div className="my-1">
				<LoadingIconComponent />
				<span className="align-middle">{ToString(message)}</span>
			</div>
		)
	}
}
LoadingIndicatorComponent.propTypes = {
    message: PropTypes.string,
    visible: PropTypes.bool
}
LoadingIndicatorComponent.defaultProps = {
    message: 'Loading...',
    visible: true
}
